import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, {
    class: _normalizeClass(_ctx.classes),
    color: _ctx.color,
    size: _ctx.sizeInner
  }, {
    default: _withCtx(() => [
      (_ctx.tooltip)
        ? (_openBlock(), _createBlock(_component_q_tooltip, {
            key: 0,
            "content-class": "s-tooltip",
            delay: _ctx.DELAY_TOOLTIP
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.tooltip), 1)
            ]),
            _: 1
          }, 8, ["delay"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "color", "size"]))
}